import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useQuery } from '@tanstack/react-query';
import { DEBOUNCE_DELAY } from 'utils/constants/app/magic-numbers-app';
import { ECasinoQueryKey } from 'utils/constants/store/query-keys';
import { CommandNames } from 'utils/constants/swarm/swarm-command-names';
import {
  CrashGamesDataResults,
  CrashGamesResponse,
  CrashGamesResponseResultItem
} from 'interfaces/casino-data';
import { swarmCommand } from 'services/get-swarm-data';
import {
  setOnlinePlayersCrashGamesIds,
  setOnlinePlayesCrashGamesData
} from 'store/actions';
import { getOnlinePlayersCrashGamesIds } from 'store/selectors/casino-data';

export const CASINO_PROVIDER_CRASH_GAMES = '406';

const CASINO_CRASH_RESULTS_COUNT = 10;

export const useCasinoOnlinePlayers = (): {
  updateCrashGamesIds: (ids: Array<number>) => void;
} => {
  const dispatch = useDispatch();

  const crashGamesIds = useSelector(getOnlinePlayersCrashGamesIds);

  const crashGamesEffect = () => {
    if (crashGamesIds.length) {
      swarmCommand(
        CommandNames.GET_PROVIDER_CRASH_GAMES,
        { game_ids: crashGamesIds },
        (data: CrashGamesResponse) => {
          if (data.result === 0 && !data.details.HasError) {
            const games: CrashGamesDataResults = {};

            data.details.Result.forEach(
              (game: CrashGamesResponseResultItem) => {
                games[game.GameId] = {
                  onlinePlayerCount: game.OnlinePlayersCount,
                  results: game.Results.slice(-CASINO_CRASH_RESULTS_COUNT)
                };
              }
            );

            dispatch(setOnlinePlayesCrashGamesData(games));
          }
        }
      );
    }

    return () => {
      // This is useEffect or useQuery.queryFn return function.
    };
  };

  useEffect(crashGamesEffect, [crashGamesIds.length]);
  useQuery({
    queryKey: [ECasinoQueryKey.CasinoCrashGames],
    queryFn: crashGamesEffect,
    refetchOnWindowFocus: true,
    refetchInterval: DEBOUNCE_DELAY._20000
  });

  return {
    updateCrashGamesIds: (ids: Array<number>) => {
      dispatch(
        setOnlinePlayersCrashGamesIds(
          [...new Set([...ids, ...crashGamesIds])].sort()
        )
      );
    }
  };
};
